'use client';

import { DisplayedCarInfoInterface, Showroom } from '@/types';
import { useState } from 'react';
import Typography from '@/components/shared/typography/typography.component';
import { AVAILABLE_LANGUAGES } from '@/constants';
import dynamic from 'next/dynamic';
import {
    ChevronRightArrowBlack,
    ChevronRightArrowGreen,
    MapPin,
} from 'public/Images';
import { LocationIcon } from '../../../../../../public/Images/Icons';
import Image from 'next/image';
import useTranslationHook from '@/hook/use-translation-client.hook';
import colors from '@/theme/colors.module.scss';
const ShowroomModal = dynamic(
    () => import('./ShowroomModal').then(mod => mod.default),
    {
        ssr: false,
    }
);
const ShowroomSection = ({
    showroom,
    lang,
    isDesktop,
    carInfo,
    setNotifyModal,
    seeCarButtonClicked,
}: {
    showroom: Showroom;
    lang: AVAILABLE_LANGUAGES;
    isDesktop: boolean;
    carInfo: DisplayedCarInfoInterface;
    setNotifyModal: React.Dispatch<React.SetStateAction<boolean>>;
    seeCarButtonClicked: () => void;
}) => {
    const [modalOpen, setModalOpen] = useState(false);
    const { t } = useTranslationHook();
    return (
        <>
            {modalOpen && (
                <ShowroomModal
                    open={modalOpen}
                    lang={lang}
                    onClose={setModalOpen}
                    showroom={showroom}
                    isDesktop={isDesktop}
                    carInfo={carInfo}
                    setNotifyModal={setNotifyModal}
                    seeCarButtonClicked={seeCarButtonClicked}
                />
            )}
            <div
                className={
                    'flex w-full flex-col items-start gap-2 pb-4 border-b-[1px] border-gray-200'
                }
            >
                <Typography
                    variant="body2Medium"
                    className="text-gray-500 hidden md:block"
                >
                    {`${t('Showroom')} : ${
                        lang === 'en' ? showroom.name.en : showroom.name.ar
                    }`}
                </Typography>
                <div
                    className={
                        'flex w-full justify-between cursor-pointer max-md:gap-1.5 max-md:bg-gray-50 max-md:px-2 max-md:py-1 max-md:rounded-lg'
                    }
                    onClick={() => {
                        setModalOpen(true);
                    }}
                >
                    <div className="flex items-center gap-2 max-w-[90%]">
                        <Image
                            src={MapPin}
                            className="min-w-5 min-h-5 ar:mb-1 block md:hidden"
                            width={20}
                            height={20}
                            alt="MapPin"
                        />

                        <Image
                            src={LocationIcon}
                            alt={'otherInfoIcon'}
                            color={colors.primary600}
                            width={20}
                            height={20}
                            className="hidden md:block"
                        />

                        <Typography
                            variant={'caption'}
                            className="text-gray-800 md:hidden"
                            style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {lang === 'en'
                                ? showroom.address.en
                                : showroom.address.ar}
                        </Typography>

                        <Typography
                            variant={'body1Medium'}
                            className="text-gray-700 max-md:hidden"
                            style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {lang === 'en'
                                ? showroom.address.en
                                : showroom.address.ar}
                        </Typography>
                    </div>

                    <Image
                        src={ChevronRightArrowBlack}
                        width={20}
                        height={20}
                        alt="Chevron Right"
                        className="ar:rotate-180 md:hidden"
                    />

                    <Image
                        src={ChevronRightArrowGreen}
                        width={24}
                        height={24}
                        alt="Chevron Right"
                        className="ar:rotate-180 max-md:hidden"
                    />
                </div>
            </div>
        </>
    );
};

export default ShowroomSection;
